// extracted by mini-css-extract-plugin
export default {"form__wrapper":"StepFormItem_form__wrapper__eASJm","column":"StepFormItem_column__jakr5","form__item":"StepFormItem_form__item__6rcvd"};